import {VouchersFormProvider} from "./vouchers-form-context";
import Vouchers from "./vouchers";

const VoucherifyCheckoutBlock = () => {
		return (
			<VouchersFormProvider>
				<Vouchers />
			</VouchersFormProvider>
		);
};

export default VoucherifyCheckoutBlock;
